<script setup lang="ts">
    import { initValidators } from '@/services/validators/initialize';
    import TheToastersManager from '@/components/TheToastersManager.vue';
    import TheLoader from '@/components/TheLoader.vue';
    import DesktopView from '@/views/DesktopView.vue';
    import MobileView from '@/views/MobileView.vue';
    import { useConfigStore } from '@/store/config.store';
    import { WFabricWorld } from '@/littleWedding/WFabricWorld';
    import PreviewBATModal from '@/components/PreviewBATModal.vue';
    import { EProductFormat } from '@/typescript/enums/EProductFormat';
    import { dataStore } from '@/commons/DataStore';
    import { onMounted, onUnmounted } from 'vue';
    import { storeToRefs } from 'pinia';

    const { isAppLoading, isBATModalVisible, isMobile, isStoreInitialized, productFormat } = storeToRefs(useConfigStore());

    dataStore.wFabricWorldRecto = new WFabricWorld();

    if (productFormat.value === EProductFormat.RECTO_VERSO) {
        dataStore.wFabricWorldVerso = new WFabricWorld();
    }
    // For more information, see https://vitejs.dev/guide/build#load-error-handling
    function onVitePreloadError() {
        globalThis.location.reload();
    }

    onMounted(() => {
        initValidators();
        globalThis.addEventListener('vite:preloadError', onVitePreloadError);
    });
    onUnmounted(() => {
        globalThis.removeEventListener('vite:preloadError', onVitePreloadError);
    });
</script>

<template>
    <TheLoader v-if="isAppLoading" />
    <div
        v-if="isStoreInitialized"
        :class="[isMobile && 'h-dvh', !isMobile && 'h-full', 'w-full']"
    >
        <MobileView v-if="isMobile" />
        <DesktopView v-else />
    </div>
    <TheToastersManager />
    <transition
        enter-from-class="opacity-0"
        enter-to-class="opacity-100"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
        class="duration-300"
    >
        <PreviewBATModal
            v-if="isBATModalVisible"
            @close="isBATModalVisible = false"
        />
    </transition>
</template>

<style>
    #app {
        position: absolute;
        width: 100%;
        height: 100svh;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        touch-action: auto;
    }
</style>
